<ds-card-expiration-input
  class="w-100"
  [formControl]="formControl"
  [label]="props.label || 'Expiration date'"
  [helper]="helper"
  [error]="error"
  [inputId]="id"
  (valueChange)="onExpirationChange($event)"
/>
<formly-validation-message *ngIf="showError" class="d-none" [field]="field" />
